module.exports = __webpack_public_path__ + "media/St 4-light switch-incorrect.17dfddcc.wav";